import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEmploymentDetailsPage = {
  alert: {
    error: 'coapplicant-employment-details.form.alert.error',
  },
  footer: {
    root: 'coapplicant-employment-details.footer.root',
  },
  form: {
    employerNameInput:
      'coapplicant-employment-details.form.employer-name-input',
    employerNameInputError:
      'coapplicant-employment-details.form.employer-name-input-error',
    grossAnnualIncomeInput:
      'coapplicant-employment-details.form.gross-annual-income-input',
    grossAnnualIncomeInputError:
      'coapplicant-employment-details.form.gross-annual-income-input-error',
    h1: 'coapplicant-employment-details.form.h1',
    h2: 'coapplicant-employment-details.form.h2',
    jobTitleInput: 'coapplicant-employment-details.form.job-title-input',
    jobTitleInputError:
      'coapplicant-employment-details.form.job-title-input-error',
    root: 'coapplicant-employment-details.form.root',
    submitButton: 'coapplicant-employment-details.form.submit-button',
  },
  header: {
    drawerButton: 'coapplicant-employment-details.header.drawer-button',
    previousStepButton:
      'coapplicant-employment-details.header.previous-step-button',
    root: 'coapplicant-employment-details.header.root',
  },
  progress: {
    root: 'coapplicant-employment-details.progress.root',
  },
} as const satisfies PageLocatorMap;
